<form [formGroup]="form" class="d-block navigation">
  <div class="d-flex justify-content-between align-items-baseline">
    <rx-icon
      name="chevron-left"
      class="navigation__arrow"
      [fill]="dateNavigationService.isArrowEnabled(this.datePickerInstance, 'left') ? 'primary' : 'grey'"
      [attr.data-qa]="testIdPrefix + '-left-arrow'"
      (click)="onArrowClick('left')"
    />

    <!-- Mobile view: Month and Year selectors -->
    <div class="d-flex d-lg-none justify-content-between">
      <rx-select
        class="navigation__month mr-1"
        formControlName="leftMonth"
        selectId="leftMonth"
        [options]="getMobileMonths()"
        [compact]="true"
        [attr.data-qa]="testIdPrefix + '-left-month'"
      />
      <rx-select
        class="navigation__year"
        formControlName="leftYear"
        selectId="leftYear"
        [options]="yearList"
        [compact]="true"
        [attr.data-qa]="testIdPrefix + '-left-year'"
      />
    </div>

    <!-- Desktop view: LEFT side Month and Year selectors -->
    <div class="d-none d-lg-flex justify-content-between">
      <rx-select
        class="navigation__month mr-1"
        formControlName="leftMonth"
        selectId="leftMonth"
        [options]="getLeftMonths()"
        [compact]="true"
        [attr.data-qa]="testIdPrefix + '-left-month'"
      />
      <rx-select
        class="navigation__year"
        formControlName="leftYear"
        selectId="leftYear"
        [options]="yearList"
        [compact]="true"
        [attr.data-qa]="testIdPrefix + '-left-year'"
      />
    </div>

    <!-- Desktop view: RIGHT side Month and Year selectors -->
    <div class="d-none d-lg-flex justify-content-between ml-4">
      <rx-select
        class="navigation__month mr-1"
        formControlName="rightMonth"
        selectId="rightMonth"
        [options]="getRightMonths()"
        [compact]="true"
        [attr.data-qa]="testIdPrefix + '-right-month'"
      />
      <rx-select
        class="navigation__year"
        selectId="rightYear"
        formControlName="rightYear"
        [options]="yearList"
        [compact]="true"
        [attr.data-qa]="testIdPrefix + '-right-year'"
      />
    </div>

    <rx-icon
      name="chevron-right"
      class="navigation__arrow"
      [fill]="dateNavigationService.isArrowEnabled(this.datePickerInstance, 'right') ? 'primary' : 'grey'"
      [attr.data-qa]="testIdPrefix + '-right-arrow'"
      (click)="onArrowClick('right')"
    />
  </div>
</form>
